import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { addSlrConnectMsg } from '../../store/actions/campaignActions';

export class NewLiStep extends Component {
  state = {
    campaign: '',
    connectmsg: '',
    client: '',
    leadName: ''
  };
  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.addSlrConnectMsg(this.state);
    this.props.history.push('/slr-messaging/' + this.props.match.params.id);
  };
  componentDidMount() {
    this.setState({
      ...this.state,
      campaign: this.props.match.params.id
    });
  }
  render() {
    return (
      <div className="container">
        <div className="card">
          <div className="card-content">
            <span className="card-title">
              Adding a New Invitation to Connect Message
            </span>
            <form onSubmit={this.handleSubmit}>
              <div className="input-field">
                <label htmlFor="connectmsg">Connect Message:</label>
                <input
                  type="text"
                  id="connectmsg"
                  onChange={this.handleChange}
                />
              </div>
              <span style={{ fontSize: '12px' }}>
                Merge tags:
                <br />
                #firstName# - First Name
                <br />
                #lastName# - Last Name
                <br />
                #company# - Company Name
                <br />
              </span>
              <br />
              <button className="btn green">Save</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const users = state.firestore.data.users;
  return {
    auth: state.firebase.auth,
    users
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addSlrConnectMsg: msg => dispatch(addSlrConnectMsg(msg))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  firestoreConnect([{ collection: 'slrcampaigns' }])
)(NewLiStep);
